import { apiSlice } from '../../api/slice'

export const stakingApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStakeInformation: builder.query({
      query: ({ tierIndex }) => ({
        url: `/vault/user/stake-information/${tierIndex}`,
      }),
    }),
    getTokensStakeInformation: builder.query({
      query: () => ({
        url: `/user/stake-information/tokens`,
      }),
    }),
    getTokensClaimHistory: builder.query({
      query: () => ({
        url: `/vesting/tokens/claim-history`,
      }),
    }),
    getSablierWithdrawals: builder.query({
      query: () => ({
        url: `/user/sablier-withdrawals`,
      }),
    }),
    getUniversalVaultVestingInformation: builder.query({
      query: () => ({
        url: `/vesting/user/universal-vesting-information`,
      }),
    }),
  }),
})

export const {
  useGetStakeInformationQuery,
  useLazyGetStakeInformationQuery,
  useGetTokensStakeInformationQuery,
  useLazyGetTokensStakeInformationQuery,
  useGetTokensClaimHistoryQuery,
  useLazyGetTokensClaimHistoryQuery,
  useGetSablierWithdrawalsQuery,
  useLazyGetSablierWithdrawalsQuery,
  useGetUniversalVaultVestingInformationQuery,
} = stakingApiSlice
